<div class="container-card">
  <p class="title-informations margin-y">{{ title }}</p>
  <div class="vertical-buttons">
    @for (linkToPageButton of linkToPageButtons; track $index) {
      <div
        #tooltipRef="matTooltip"
        (mouseenter)="tooltipRef.show()"
        (mouseleave)="tooltipRef.hide()"
        [matTooltip]="linkToPageButton.tooltipMessage || ''"
        [matTooltipPosition]="TooltipPosition.RIGHT"
      >
        @if (linkToPageButton.external) {
          <a
            mat-button
            mat-raised-button
            class="custom-button"
            href="{{ linkToPageButton.link }}"
            target="_blank"
            rel="noopener"
          >
            <span class="inner-custom-button">
              <img src="{{ linkToPageButton.img }}" alt="{{ linkToPageButton.name }}" />
              <span>{{ linkToPageButton.name }}</span>
              <mat-icon class="arrow-icon">keyboard_arrow_right</mat-icon>
            </span>
          </a>
        } @else if (
          !isEmptyOrNull(linkToPageButton.authorizeGroup) &&
          linkToPageButton.authorizeGroup.includes('autres-outils') &&
          linkToPageButton.name !== 'Cockpit'
        ) {
          <a
            mat-button
            mat-raised-button
            class="custom-button"
            href="{{ linkToPageButton.link }}"
            target="_blank"
            rel="noopener"
          >
            <span class="inner-custom-button">
              @if (isEmptyOrNull(linkToPageButton.img)) {
                <span>{{ linkToPageButton.name }}</span>
              } @else {
                <img
                  src="{{ linkToPageButton.img }}"
                  alt="{{ linkToPageButton.name }}"
                  class="logo-externe"
                />
              }
              <mat-icon class="arrow-icon">keyboard_arrow_right</mat-icon>
            </span>
          </a>
        } @else {
          <a
            mat-button
            mat-raised-button
            class="custom-button"
            routerLink="{{ linkToPageButton.link }}"
          >
            <span class="inner-custom-button">
              <img src="{{ linkToPageButton.img }}" alt="{{ linkToPageButton.name }}" />
              <span>{{ linkToPageButton.name }}</span>
              <mat-icon class="arrow-icon">keyboard_arrow_right</mat-icon>
            </span>
          </a>
        }
      </div>
    }
  </div>
</div>
